export const DARK_THEME = "dark.theme";
export const TEAM_SHARE = "team.share";
export const WORK_QUALITY = "work.quality";
export const WELLBEING_FULFILLING = "wellbeing.fulfilling";
export const WELLBEING_CONNECTED = "wellbeing.connected";
export const ANALYTICS_V1 = "analytics.v1";
export const EXECUTIVE_SHOW_ALL = "executive.all";

export const defaultUserFlags = {
    // PROD
    "eb168cdc-7a70-481d-b3a5-cec7028211e0:auth0|614912192176720070959f6e": {
        [ANALYTICS_V1]: true,
    },
};
export const defaultOrgFlags = {
    // PROD
};
